module.exports = __webpack_public_path__ + "img/phone.37494cdb.svg";